import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
// import { InstaImage } from './instaImage';
@Injectable({
  providedIn: 'root',
})
export class InstaService {
  constructor(private http: HttpClient) {
    var obj;
  }
  getImages() {
    return (
      this.http
        .get<any>('../../../assets/json/insta.json')
        .toPromise()
        //.then((res) => <InstaImage[]>res.data)
        .then((data) => {
          return data;
        })
    );
  }
}
